import { addUnit, isDef } from '@xzx-design/utils'

import type { CSSProperties } from 'vue'
import type { Numeric } from '@xzx-design/utils'

function trimExtraChar(value: string, char: string, regExp: RegExp) {
  const index = value.indexOf(char)

  if (index === -1) {
    return value
  }

  if (char === '-' && index !== 0) {
    return value.slice(0, index)
  }

  return value.slice(0, index + 1) + value.slice(index).replace(regExp, '')
}

/**
 * 格式化数字
 * @param value
 * @param allowDot 是否允许小数点
 * @param allowMinus 是否允许负号
 * @param allowLeadingZero 是否允许前导零 例如 0123 -> 123, 0000.123 -> 0.123
 * @param decimalPlaces 小数位数
 * @returns value
 */
export function formatNumber(
  value: string,
  allowDot = true,
  allowMinus = true,
  allowLeadingZero = false,
  decimalPlaces = -1
) {
  if (allowDot) {
    value = trimExtraChar(value, '.', /\./g)
  } else {
    value = value.split('.')[0]
  }

  if (allowMinus) {
    value = trimExtraChar(value, '-', /-/g)
  } else {
    value = value.replace(/-/, '')
  }

  if (decimalPlaces > 0 && value.split('.')[1]) {
    value = `${value.split('.')[0]}.${value
      .split('.')[1]
      ?.slice(0, decimalPlaces)}`
  }

  const regExp = allowDot ? /[^-0-9.]/g : /[^-0-9]/g
  value = value.replace(regExp, '')

  // 处理前导零
  if (!allowLeadingZero) {
    const parts = value.split('.')
    parts[0] = parts[0].replace(/^0+(?=\d)/, '') // 去除整数部分的前导零
    value = parts.join('.')
  }

  return value
}

export function getZIndexStyle(zIndex?: Numeric) {
  const style: CSSProperties = {}
  if (zIndex !== undefined) {
    style.zIndex = +zIndex
  }
  return style
}

export function getSizeStyle(
  originSize?: Numeric | Numeric[]
): CSSProperties | undefined {
  if (isDef(originSize)) {
    if (Array.isArray(originSize)) {
      return {
        width: addUnit(originSize[0]),
        height: addUnit(originSize[1]),
      }
    }
    const size = addUnit(originSize)
    return {
      width: size,
      height: size,
    }
  }
}

const camelizeRE = /-(\w)/g

export const camelizeX = (str: string): string =>
  str.replace(camelizeRE, (_, c) => c.toUpperCase())

export function padZero(num: Numeric, targetLength = 2): string {
  let str = `${num}`

  while (str.length < targetLength) {
    str = `0${str}`
  }

  return str
}
